export enum AuthEndpoint {
  SigninCallback = 'signin-oidc',
  Logout = 'logout',
  LogoutCallback = 'logout/callback',
  SigninSilentCallback = 'silentrenew'
}

export enum AuthRoutes {
  SigninCallback = '/signin-oidc',
  Logout = '/logout',
  LogoutCallback = '/logout/callback',
  SigninSilentCallback = '/silentrenew'
}
